import { calcCount, mockInsightData } from '@/shared/job/insight.dto';
import { hasInsightItems } from '@/features/jobs/lib/hasInsightItems';
import { IOptions } from '@/shared/options';
import { BookOpen } from 'lucide-react';
import { cn } from '@/lib/utils/utils';
import { InsightCardIcon } from './InsightCardIcon';
import { insightBlurClass } from '@/features/jobs/lib/insightBlurClass';
import { getTopSkillItems } from '@/features/jobs/lib/topSkillItems';

export function InsightFrequencyCard({
  title,
  items,
  isEnglish,
}: {
  title: string;
  items: (IOptions & { count: number })[];
  isEnglish: boolean;
}) {
  const hasData = hasInsightItems(items);
  const sorted = hasData
    ? getTopSkillItems(items)
    : getTopSkillItems(mockInsightData.compatibility);

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4">
      <div className="mb-4 flex items-center gap-2">
        <InsightCardIcon icon={BookOpen} />
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
      </div>
      <ol
        className={cn(
          'grid grid-cols-1 gap-2 sm:grid-cols-2',
          !hasData && insightBlurClass
        )}
        aria-hidden={!hasData}
      >
        {sorted.map((item, index) => (
          <li
            key={item.id}
            className="flex items-center justify-between gap-3 rounded-lg bg-secondary-50 px-3 py-2 text-sm"
          >
            <span className="min-w-0 truncate text-gray-800">
              {index + 1}. {isEnglish ? item.name_en : item.name_mn}
            </span>
            <span className="shrink-0 text-gray-500">
              {calcCount(item.count)}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}
